<template>
  <v-container class="component_main px-0">
    <v-row v-show="showList" class="px-7">
      <v-col>
        <h1>Documentos</h1>
        <p class="ma-0">Área de recebimento de documentos</p>
      </v-col>
      <v-col class="d-flex justify-end" v-if="adddocument">
        <v-btn
          height="30px" 
          small
          color="primary" 
          depressed 
          @click="selectToEditItem({}, 'edit')"
        >Novo Documento</v-btn>
      </v-col>
    </v-row>
    <!--
      -->
      <DocsForm
      v-show="!showList"
      :close="(form, file)=> form ? saveItem(form, file) : showList=!showList" 
      :selectedItem="editItem"
      :modules="modules"
      :docTipos="docTipos"
    />
    <DocsFilter
      v-show="showList"
      :modules="modules"
      :prestadores="prestadores"
      :docTipos="docTipos"
      :formatDate="(date) => formatDate(date)"
      :parseDate="(date) => parseDate(date)"
      :getList="(item, page) => getList(item, page)"
      :permission="userData.Permissao"
    />
    <v-row wrap class="d-flex flex-row">
      <v-col class="col-xs-12 col-sm-12 col-md-12 pa-0">
        <DocsList
          v-show="showList"
          :selectItem="(item, action) => selectItem(item, action)"
          :modulosTitles="modulosTitles"
          :docTipos="docTipos"
          :filter="filter"
          :getList="(formData, page) => getList(formData, page)"
          :list="filteredList"
          :headers="headers"
          :updatedocument="updatedocument"
          :getdocument="getdocument"
          :total_pages = "pageCount"
          :userData="userData"
          :offset="offset"
        />
      </v-col>
    </v-row>
    <Footer/>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import DocsList from "@/components/docs/DocsList";
import DocsForm from "@/components/docs/DocsForm";
import DocsFilter from "@/components/docs/DocsFilter";
import Footer from "@/components/common/Footer";
export default {
  components: {
    DocsList,
    DocsForm,
    DocsFilter,
    Footer
  },
  data() {
    return {
      editItem: "{}",
      filter: {
        limit: 10
      },
      filteredList: [],
      headers: [
        { text: "Documento", align: "start", value: "Documento" },
        { text: "Tipo", value: "Tipo" },
        { text: "Descrição", value: "Descricao" },
        { text: "Módulo", value: "Modulo" },
        { text: "Data", value: "Data" },
      ],
      modules: [],
      pageCount: 0,
      prestadores: [],
      showList: true,
      selectedItem: {},
      offset: 1
    };
  },
  watch: {
    grupoEconomico: {
      deep: true,
      handler() {
        let opts = {
          grupoEconomico: this.grupoEconomico,
          limitar: false
        }
        this.getDocuments(opts).then(()=> {
          this.$store.dispatch("documents/getDocTypes", this.grupoEconomico, {root:true})
        })
      },
    },
    grupoEconomicoList:{
      deep: true,
      handler(){
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    }
  },
  computed: {
    ...mapState({
      docTipos: (state) => state.documents.docTipos,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listDoc: (state) => state.documents.listDoc,
      listDocLength: (state) => state.documents.listDocLength,
      listDocTotal: (state) => state.documents.listDocTotal,
      modulosTitles: (state) => state.permissions.modulosTitles,
      userData: (state) => state.userData.userData,
    }),
    ...mapGetters({
      getModulosList: "permissions/getModulosList"
    }),
    adddocument(){
      return  this.userData.UsuarioTradimus &&  this.userData.PermissaoAcoes.portal.includes('adddocument') // this.grupoEconomico==1 && 
    },
    updatedocument(){
      return this.userData.UsuarioTradimus &&  this.userData.PermissaoAcoes.portal.includes('updatedocument') //this.grupoEconomico==1 && 
    },
    getdocument(){
      return this.userData.PermissaoAcoes.portal.includes('getdocument')
    }
  },
  beforeMount() {
    this.$store.dispatch("documents/getDocTypes", null, {root:true})
    console.log(this.pageCount);
    //this.modules = this.$store.getters["permissions/getModulosList"]()
  },
  mounted() {
    
    if(this.getdocument){
      this.headers.push({ text: "Baixar", value: "Baixar" })
    }
    if(this.updatedocument){
      this.headers.push({ text: "Ações", value: "acoes" })
    }
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
    let opts = {
          grupoEconomico: this.grupoEconomico,
          limit: 10,
          offset: 1
        }
    this.getList(opts, 1)
  },
  methods: {
    ...mapActions('documents', [
      "startData",
      "getDocuments",
      "getDocument" 
    ]),
    selectItem(item, action) {
      switch (action) {
        case "download":
          this.selectedItem = Object.assign({}, item);
          this.getDocument(this.selectedItem)
          break;

        case "edit":
          this.selectToEditItem(item, true)
          break;

        case "newDoc":
          this.showList = false;
          break;

        default:
          break;
      }
    },
     selectToEditItem(item, showForm) {
      if (!item) return;
      this.editItem = JSON.stringify(item);
      this.$nextTick(() => (this.showList = showForm ? false : this.showList));
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    // filterList(formData) {
    //   this.filter = formData
    //   let list = Array.from(this.listDoc)
    //   let newList = [];
    //   if (formData && list.length) {
    //     newList = list.reduce((arr, item) => {
    //       let matchModule = formData.modulo.toLowerCase() == item.modulo.toLowerCase() || formData.modulo == ""
    //       let matchType = formData.tipo == item.tipo || formData.tipo == null
    //       let regex = formData.search ? new RegExp(formData.search, "gi") : null
    //       let matchSearch = regex ? item.nome.match(regex) != null ||( item.mensagem && item.mensagem.match(regex) != null ): true
    //       let matchDateStart = Date.parse(formData.data_inicio) <= Date.parse(item.data_publicacao) || !formData.data_inicio  
    //       let matchDateEnd = (Date.parse(formData.data_final)+24*60*60*1000) >= Date.parse(item.data_publicacao) || !formData.data_final

    //       if(matchModule && matchType && matchSearch && matchDateStart && matchDateEnd) {
    //         arr.push(item);
    //       }
    //       return arr
    //     }, [])
    //   }
    //   this.filteredList = newList;
    // },
    getList(formData, page){
      this.filter = formData
      this.filter.limit = 10;
      this.filter.offset = page != null && page > 0 ? page : 1;
      this.offset = page != null && page > 0 ? page : 1;
      let opts = {
        grupoEconomico: this.grupoEconomico,
        tipo: formData.tipo,
        modulo: formData.modulo,
        search: formData.search,
        data_inicio: formData.data_inicio,
        data_fim: formData.data_final,
        limit: 10,
        prestador: formData.prestador!=""?formData.prestador: null,
        offset: this.filter.offset
      }
      this.getDocuments(opts).then(()=>{
        this.filteredList =  Array.from(this.listDoc)
        setTimeout(()=>{
          this.pageCount =  this.listDocTotal%this.filter.limit > 0? parseInt(this.listDocTotal/this.filter.limit) +1 : parseInt(this.listDocTotal/this.filter.limit);
        },20)
      })
    },
    saveItem(formData, file) {
            
            formData.grupo_economico = this.grupoEconomico
            let acao = formData.id ? "updatedocument" : "adddocument"
            let payload = JSON.stringify(formData)
            var data = new FormData();
            data.append('Modulo', 'portal');
            data.append('Acao', acao);
            data.append('Payload', payload);
            data.append('File', file);
      this.$store.dispatch("request/sendFile", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getDocuments(this.grupoEconomico).then(()=>this.showList = true)
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    deleteDocument(id) {
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "deletedocument",
            Payload: {
              Id: id,
            },
          },
        ],
      };

      this.$store.dispatch("request/doRequest", obj)
    },
    isTradimus() {
      let userData = this.$store.state.userData.userData
      if(userData.UsuarioTradimus && userData.Permissao.portal.includes('administrador')){
        return true
      } else {
        return false
      }
    }
  },
};
</script>
<style>
</style>